import { boot, eraroCodesMap, createEraroError } from '@dazn/bootstrap-lib';

import { GetGuid, GetDevMode } from './common-types';
import { getHeaders } from './getHeaders';

const logout = (
    url: string,
    token: string,
    deviceId: string,
    fetch: boot.util.Fetch,
    getGuid: GetGuid,
    getDevMode: GetDevMode,
    brandName: string,
    customHeaders?: {
        isCustomHeadersEnabled?: boolean;
        brandName?: string;
        daznId?: string;
    },
) =>
    fetch(url, {
        method: 'POST',
        headers: getHeaders(
            token,
            getGuid,
            getDevMode,
            undefined,
            undefined,
            customHeaders,
        ),
        body: JSON.stringify({
            DeviceId: deviceId,
            ...(brandName && { brand: brandName }),
        }),
    }).then(
        response => {
            if (!response.ok) {
                throw createEraroError(
                    'Logout responded not okay',
                    eraroCodesMap.category.UserProfileService,
                    eraroCodesMap.code.GenericError,
                    String(response.status),
                );
            }

            return;
        },
        error => {
            throw createEraroError(
                'Logout attempt request failure',
                eraroCodesMap.category.UserProfileService,
                eraroCodesMap.code.GenericError,
                eraroCodesMap.internal.NetworkError,
                error,
            );
        },
    );

export { logout };
